export default "__VITE_ASSET__BEI5c8bC__"